import { IClientDetail } from '@app/modules/client-management/types/client-detail';
import { IMDMCustomer } from '../../modules/user-management/types/mdm-customer';
import {
    IGenerateQROnboardingPayload,
    IQROnboardingDetails,
} from '../../modules/user-management/types/qr-onboarding';

export const GENERATE_QR_DETAILS_INITIAL_STATE: IGenerateQROnboardingPayload = {
    id: '0',
    name: '',
    expirationDate: '',
    description: '',
    onboarding: 0,
    onBoardingOptions: '',
};

export const QR_DETAILS_INITIAL_STATE: IQROnboardingDetails = {
    qrCodeId: '',
    name: '',
    qrLink: '',
    expirationDate: '',
};

export const CLIENT_INFO_INITIAL_STATE: IMDMCustomer = {
    mdmId: '0',
    accountName: '',
    addr1: '',
    addr2: '',
    city: '',
    state: '',
    postalCode: '',
    countryCode: '',
};

export const CLIENT_DETAIL_INITIAL_STATE: IClientDetail = {
    company: {
        name: '',
        address: '',
    },
    primaryUser: {
        userPhoneNumber: '',
        userEmail: '',
        userName: '',
        userRole: '',
    },
    activeQRCodes: {
        isEnableAddQRCode: false,
        maxActiveQRCodes: 0,
        numberOfActiveQRCodes: 0,
    },
};

export const COMPANY_STORE_INITIAL_STATE: CompanyStoreState = {
    clientInfo: CLIENT_INFO_INITIAL_STATE,
    qrDetails: QR_DETAILS_INITIAL_STATE,
    generateQRDetails: GENERATE_QR_DETAILS_INITIAL_STATE,
    id: '0',
    clientDetailInfo: CLIENT_DETAIL_INITIAL_STATE,
    isBusy: false,
    clientLogo: '',
};
export interface CompanyStoreState {
    clientInfo: IMDMCustomer;
    qrDetails: IQROnboardingDetails;
    generateQRDetails: IGenerateQROnboardingPayload;
    id: string;
    clientDetailInfo: IClientDetail;
    isBusy: boolean;
    clientLogo: string;
}
